export const defaultMonthlyIncomeAgreements = {
  monthlyIncome: 0,
  incomeDocNumber: null,
  incomeDocDate: '',
};

export const defaultDebtLoadFormValues = {
  clientId: "",
  currentDealAmount: 0,
  creditDebt: undefined,
  loanPayment: undefined,
  leasingDebt: undefined,
  leasingPayment: undefined,
  microloanDebt: undefined,
  microloanPayment: undefined,
  goodsDebt: undefined,
  goodsPayment: undefined,
  expireDebt: undefined,
  expirePayment: undefined,
  otherDebt: undefined,
  monthIncomeDocs: [defaultMonthlyIncomeAgreements],
  isPensioner: undefined,
  isEmployed: undefined,
  monthlyPension: undefined,
  isIncomeConfirmed: false,
  employmentIndustry: null,
  monthlyIncomeIndustry: "",
  monthlyIncome: null,
  pensionIncomeDoc: defaultMonthlyIncomeAgreements,
};

export const RADIO_NAMES = {
  IS_WORKING: "isEmployed",
  MONTHLY_PAYMENT: "isDebtExists",
  IS_CREDIT_DEBT: "isCreditDebt",
  IS_LEASING_DEBT: "isLeasingDebt",
  IS_MICROLOAN_DEBT: "isMicroloanDebt",
  IS_GOODS_DEBT: "isGoodsDebt",
  IS_EXPIRE_DEBT: "isExpireDebt",
  IS_OTHER_DEBT: "isOtherDebt",
  IS_GUARANTEE_AGREEMENTS: "isGuaranteeAgreements",
};

export const DEBT_REPORT_KEYS = {
  TOTAL_DEAL_AMOUNT: "Сумма микрозаймов, находящихся в обороте",
  TOTAL_DEBT_LOAD_DEAL_AMOUNT: "Сумма с превышением ПДН",
  TOTAL_COUNT_DEALS: "Количество микрозаймов, находящихся в обороте",
  TOTAL_COUNT_DEBT_OVERLOADED_DEALS: "Количество с превышением ПДН",
};

export const REPORT_TYPE_MAPPING = {
  "Проверить данные на текущий момент": "current",
  "Проверить данные на дату": "custom",
  "За период": "period",
};
